import React, { useEffect, useState } from "react";

//UI Material
import {
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

export default function ClientQuotes({ quotes = [] }) {
  // ==========> Component States <==========
  //State for loading products from db
  const [isLoading, setIsLoading] = useState(true);
  //State for error in request from db
  const [isError, setIsError] = useState(false);
  //State for client products objects
  const [clientQuotes, setClientQuotes] = useState([]);
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // ==========> Component Functions <==========
  //Function to get client data from db
  const getClientQuotes = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/quotes/get-quotes-by-ids`,
        {
          quotesIds: quotes,
        }
      );
      const jsonResponse = await requestResponse.json();
      setClientQuotes(jsonResponse.data);
    } catch (error) {
      setIsError(true);
    }
    setIsLoading(false);
  };

  //Function to display products rows
  const generateQuotesRows = () => {
    if (isLoading) {
      return (
        <TableRow>
          <TableCell colSpan={3} align="center">
            <CircularProgress />
          </TableCell>
        </TableRow>
      );
    }

    if (isError) {
      return (
        <TableRow>
          <TableCell colSpan={4} align="center">
            No se pudo obtener la lista de cotizaciones registradas
          </TableCell>
        </TableRow>
      );
    }

    if (clientQuotes && clientQuotes.length > 0) {
      return clientQuotes.map((quote) => (
        <TableRow key={`quote-#${quote.quoteNumber}`}>
          <TableCell align="center">{quote.quoteNumber}</TableCell>
          <TableCell align="center">
            {new Date(quote.createdAt).toLocaleDateString()}
          </TableCell>
          <TableCell align="center">
            <Stack>
              {quote.products.map((p) => (
                <Typography key={p.productName + p.id} variant="body2">
                  {p.productName}
                </Typography>
              ))}
            </Stack>
          </TableCell>
          <TableCell align="center">
            <Button
              variant="contained"
              size="small"
              color="secondary"
              sx={{ color: "white" }}
              onClick={() => {
                window.location.href = `/quote?id=${quote.quoteNumber}`;
              }}
              endIcon={<ArrowForwardIos />}
            >
              Ver cotización
            </Button>
          </TableCell>
        </TableRow>
      ));
    }

    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          Sin cotizaciones registrados
        </TableCell>
      </TableRow>
    );
  };

  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };
  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ==========> Component UseEffects <==========
  //The useEffect checks for token validation
  useEffect(() => {
    getClientQuotes();
  }, []);

  // ==========> Component <==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <Grid item xs={12}>
          {typographyForSubtitles(
            "Historial de cotizaciones del cliente",
            "secondary"
          )}
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" spacing={1} alignItems="center">
            {typographyForSubtitles(quotes.length)}
            {typographyForText("cotizaciones registradas")}
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Table aria-label="orders-of-client-table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "No. Cotización",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Fecha de emisión",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Descripción",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Acciones",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{generateQuotesRows()}</TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={clientQuotes.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Filas"
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
